import { ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import { CrownIconComponent, SubscribeMenuItem } from '../layout/UserMenu';
import { SubscriptionButtonWithIcon } from '../ui/Button';
import SubscriptionModal from './SubscriptionModal';

interface SubscriptionTeasingProps {
  teasingButton: string;
  title: string;
  text: string;
  link: string;
}

const SubscriptionTeasing = ({
  title,
  text,
  teasingButton,
  link
}: SubscriptionTeasingProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <SubscriptionButtonWithIcon onClick={handleOpen}>
        {teasingButton}
      </SubscriptionButtonWithIcon>

      <SubscriptionModal
        open={open}
        onClose={handleClose}
        title={title}
        text={text}
        link={link}
      />
    </>
  );
};

export const MenuItemTeasing = ({
  title,
  text,
  teasingButton,
  link,
  onOpen
}: SubscriptionTeasingProps & {
  onOpen?: () => void;
}) => {
  const handleOpen = () => {
    onOpen?.();
  };

  return (
    <SubscribeMenuItem onClick={handleOpen}>
      <ListItemIcon>
        <CrownIconComponent />
      </ListItemIcon>
      <ListItemText>{teasingButton}</ListItemText>
    </SubscribeMenuItem>
  );
};

export default SubscriptionTeasing;
